import React from 'react';
import Hero from "../components/Hero";
import Benefits from "../components/Benefits";
import ProjectInfo from "../components/ProjectInfo";
import FacadeSection from "../components/FacadeSection";
import AvailabilityCounter from "../components/AvailabilityCounter";
import Location from "../components/Gallery";
import ContactForm from "../components/ContactForm";
import TextImageSection from "../components/TextImageSection";
import PhotoGallery from "../components/PhotoGallery";
import { useHomepageLayout } from "../lib/hooks/useHomepageLayout";

// Maps a section key to its component. The Hero banner is always rendered
// first and is not part of the reorderable layout.
const SECTION_COMPONENTS: Record<string, React.ComponentType> = {
  benefits: Benefits,
  projectInfo: ProjectInfo,
  textImage: () => <TextImageSection blockKey="textImage" imageSide="right" />,
  imageText: () => <TextImageSection blockKey="imageText" imageSide="left" />,
  facade: FacadeSection,
  availability: AvailabilityCounter,
  photoGallery: PhotoGallery,
  gallery: Location,
  contact: ContactForm,
};

const HomePage = () => {
  const { layout } = useHomepageLayout();

  return (
    <>
      <Hero />
      {layout.sections
        .filter((s) => s.enabled)
        .map((s) => {
          const Component = SECTION_COMPONENTS[s.key];
          return Component ? <Component key={s.key} /> : null;
        })}
    </>
  );
};

export default HomePage;
